import React from 'react';
import Ribbon from '../Ribbon/Ribbon.js';
import Header from '../Header/Header';
import Images from '../ImagesComponent/Images';
import ReactPaginate from 'react-paginate';
import FooterSimple from '../Footer/FooterSimple.js';
import ThumbnailMitraDetail from '../Thumbnail/ThumbnailMitraDetail.js';
import ThumbnailMitraBanner from '../Thumbnail/ThumbnailMitraBanner.js';
import ThumbnailCategory from '../Thumbnail/ThumbnailCategory.js';
import M from 'moment';
import '../css/Home.css';
import '../css/MitraDetail.css';
import MetaTagContent from './MetaTagContent';

class MitraDetail extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			page: 1,
			data: "",
			dataBig: [],
			dataSmall: []
		}
	}

	componentDidMount() {
		const currentUrl = window.location.href.split('/')
		if (currentUrl.length < 2) window.location.href = '/'
		const instituteID = currentUrl[currentUrl.length - 1]
		this.getDataMitra(instituteID)
	}

	getContent(instituteID) {
		let dataBig = []
		let dataSmall = []
		fetch(process.env.REACT_APP_FETCH_URL + "/institutes/content/" + instituteID).then(content => content.json())
			.then((content) => {
				content.map(item => {
					let result = { ...item, image: process.env.REACT_APP_MITRA_DETAIL_IMAGE_URL + item.image }
					if (result.data_type === "1") dataBig.push(result)
					else dataSmall.push(result)
				})
				this.setState({ dataBig, dataSmall })
			}, (error) => console.log(error))
	}

	getCourses(instituteID) {
		let dataThumbnail = []
		fetch(process.env.REACT_APP_FETCH_URL + "/institutes/course/" + instituteID).then(course => course.json())
			.then((course) => {
				course.map(item => {
					if (item.data_type !== "konsultasi") {
						dataThumbnail.push({ ...item,
							image: process.env.REACT_APP_PRODUCT_IMAGE_URL + item.image,
							started: M(item.started, "YYYY-MM-DD HH:mm:ss").format("DD MMMM YYYY")
						})
					}
					return null
				})
				const totalPage = Math.ceil(dataThumbnail.length / 9);

				this.setState({ dataThumbnail, totalPage })
			}, (error) => console.log(error))
	}

	getDataMitra = (instituteID) => {
		fetch(process.env.REACT_APP_FETCH_URL + "/institutes/" + instituteID).then(res => res.json())
			.then((res) => {
				if (res.length  == 0) {
					return;
				}

				res.map(item => {
					let data = { ...item, image: process.env.REACT_APP_MITRA_IMAGE_URL + item.image }
					this.setState({ data })
				})

				this.getContent(res[0].the_id);
				this.getCourses(res[0].the_id);
        setTimeout(() => {
          window.testFunction();
        }, 500);
			}, (error) => console.log(error))
	}

	setPage = (args) => {
        const selectedPage = args.selected +1;
        const { page } = this.state;

        this.setState({ page: selectedPage }, () => {
          console.log('return of the king');
        });
    }

	render() {
		const { data, dataBig, dataSmall, dataThumbnail, totalPage, page } = this.state
		return (
			<div id="mitra-detail-page-container">
				{
					data &&
					data.image !== '' &&
					<MetaTagContent image={data.image}/>
				}
				<Ribbon />
				<Header />
				<div>
					<div className="container-fluid baner" id="mitra-page-baner">
						<div className="container" style={{padding:'0 4px'}}>
							<div className=" grey-border detail">
									<div>
										<Images src={data ? data.image : ""} />
									</div>
									<h3 className="mb2">{data ? data.name : ""}</h3>
									<p>{data ? data.data_type : ""}</p>
									<div style={{clear:'both'}}>
									</div>
							</div>
						</div>
					</div>
					<div className="container-fluid pagecontent" id="mitra-page">
						<div className="container mt1">
							<div className="row">
								<div className="col-md-12 col-sm-12 multiitem-container MultiCarousel">
									{dataBig && <ThumbnailMitraBanner data={dataBig} />}
									{dataSmall && <ThumbnailCategory data={dataSmall} />}
									<div className="title">
									Kelas
									</div>
									<div className="row MultiCarousel-inner">
										{dataThumbnail && dataThumbnail.map((item, index) => {
											if ( index >= (page-1)*9 && index < page*9 ) {
												return (
													<div key={index} className="item col-md-4 col-sm-6 col-xs-12">
														<ThumbnailMitraDetail cover={item.image} startdate={item.started_modified} url={item.url} />
													</div>
												)
											}
										})}
									</div>
									<div className="clearing"></div>
									{
	                                    totalPage > 1 &&
	                                    <div className="contentpagination" style={{minHeight:'70px'}}>
	                                        <ReactPaginate activeClassName="active" nextClassName="nextpage" previousLabel="" nextLabel="" previousClassName="prevpage"  pageCount={totalPage} onPageChange={this.setPage} />
	                                    </div>
	                                }
								</div>
							</div>
						</div>
					</div>
				</div>
				<FooterSimple />
			</div>
		)
	}
}

export default MitraDetail